// src/i18n/index.js (o il percorso corretto del tuo file)

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importa tutte le traduzioni
import translationEN from './en.json'; // Assumendo che en.json sia nella stessa cartella
import translationIT from './it.json'; // Assumendo che it.json sia nella stessa cartella
import translationFR from './fr.json'; // Assumendo che fr.json sia nella stessa cartella
import translationDE from './de.json'; // Assumendo che de.json sia nella stessa cartella
import translationES from './es.json'; // Assumendo che es.json sia nella stessa cartella

// Definisci le risorse per tutte le lingue
const resources = {
  en: { translation: translationEN },
  it: { translation: translationIT },
  fr: { translation: translationFR },
  de: { translation: translationDE },
  es: { translation: translationES },
};

i18n
  .use(LanguageDetector) // Rileva la lingua dell'utente
  .use(initReactI18next) // Passa i18n giù a react-i18next
  .init({
    resources, // Le tue traduzioni importate
    fallbackLng: 'it', // Lingua da usare se la traduzione per la lingua corrente non è trovata
    supportedLngs: ['it', 'en', 'fr', 'de', 'es'], // Elenco delle lingue supportate

    interpolation: {
      escapeValue: false, // React già esegue l'escape di default
    },
    
    detection: {
      // Opzioni per i18next-browser-languagedetector
      // order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      // caches: ['localStorage', 'cookie'],
      // excludeCacheFor: ['cimode'], // Lingue per cui non usare il cache
    },

    react: {
        useSuspense: false // Se non usi Suspense per il caricamento delle traduzioni
    },
    debug: process.env.NODE_ENV === 'development', // Utile per il debug in sviluppo
  });

export default i18n;